export const infoData = [
  { id: "ready", name: "READY" },
  { id: "unknown", name: "UNKNOWN" },
  { id: "inprogress", name: "IN PROGRESS" },
  { id: "failed", name: "FAILED" },
  { id: "txfailed", name: "Tx FAILED" },
  { id: "rxfailed", name: "Rx FAILED" },
  { id: "aborted", name: "ABORTED" },
  { id: "passed", name: "PASSED" },
  { id: "internalerror", name: "INTERNAL ERROR" },
  { id: "configerror", name: "CONFIG ERROR" },
  { id: "blocked", name: "BLOCKED" },
  { id: "notcalibrated", name: "NOT CALIBRATED" },
  { id: "invalidcalibration", name: "INVALID CALIBRATION" }
];



// WEBPACK FOOTER //
// ./src/components/common/results/views/fiberlengthloss/infoenum.js